let passwordKey = 'verify:admin-password';

export function configureApi(opts: { storageKey: string }): void {
  passwordKey = opts.storageKey;
}

export function setAdminPassword(p: string): void {
  sessionStorage.setItem(passwordKey, p);
}

export function getAdminPassword(): string {
  return sessionStorage.getItem(passwordKey) ?? '';
}

export function clearAdminPassword(): void {
  sessionStorage.removeItem(passwordKey);
}

export class ApiError extends Error {
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message);
  }
}

export function errMsg(err: unknown): string {
  return err instanceof Error ? err.message : String(err);
}

export async function api<T>(
  path: string,
  init: RequestInit = {},
  password?: string,
): Promise<T> {
  const resp = await fetch(`/api${path}`, {
    ...init,
    headers: {
      ...init.headers,
      'x-admin-password': password ?? getAdminPassword(),
    },
  });
  if (resp.status === 401) {
    if (password === undefined) clearAdminPassword();
    throw new ApiError(
      401,
      'Unauthorized — please re-enter the admin password.',
    );
  }
  if (!resp.ok) {
    const body = await resp.text().catch(() => '');
    throw new ApiError(
      resp.status,
      `API ${resp.status}: ${body || resp.statusText}`,
    );
  }
  return resp.json() as Promise<T>;
}
